import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { map } from 'rxjs/operators';
import { TessService } from '../services/tess.service';
import { LoggingService } from '../services/logging.service';
import { navigateToDoorbell } from '../utils/navigateToDoorbell';

export const isEntitledGuard: CanActivateFn = (route, state) => {
  const tessService: TessService = inject(TessService);
  const loggingService: LoggingService = inject(LoggingService);

  loggingService.log('APP TESS GUARD activated');

  return tessService.isTessUser$.pipe(
    map((isEntitled) => {
      if (!isEntitled) {
        loggingService.log('User is not entitled - redirecting to doorbell');
        navigateToDoorbell;
        return false;
      }
      loggingService.log('User is entitled to access app-tess');
      return true;
    }),
  );
};
